module.exports = __webpack_public_path__ + "img/40.3747ab8b.jpg";